import {inject, Injectable, signal} from '@angular/core';
import { WishListDto, Client } from '../../api/client';
import {AuthService} from './authentication/auth.service.service';

@Injectable({
  providedIn: 'root'
})

export class WishListService {
  countWish = signal(0);
  public userWish = signal<WishListDto>(null);
  client = inject(Client);
  auth = inject(AuthService)

  constructor()
  {
   this.init()
  }

  loadWishList() {
      this.client.wishList_GetWishList(1, 1000).subscribe({
        next: data => {
          this.userWish.set(data);
        },
        error: err => console.error(err)
      });
  }

  init(){
    if (this.auth.isAuthenticated()) {
      this.initWishList();
      this.loadWishList()
    }
  }

  initWishList(): void {
    this.client.wishList_GetWishListCount()
      .subscribe((res: number) => {
        this.countWish.set(res);
      });
  }

  addToWish(productIds: string[]): void {
    this.client.wishList_AddToWishList(productIds).subscribe({
      next: () => {
        this.loadWishList();
        this.initWishList();
      },
      error: (err) => {
        console.error('Ошибка:', err);
      }
    });
  }

  deleteItems(productIds: string[]): void {
    this.client.wishList_RemoveFromWish(productIds).subscribe({
      next: () => {
        this.loadWishList();
        this.initWishList();
      },
      error: (err) => {
        console.error('Ошибка:', err);
      }
    });
  }



  checkWishList(productId: string): boolean {
    return this.userWish()?.items?.some(item => item.productId == productId) ?? false;
  }
}
